// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tmlgM","question":"styles_question__1bQW0","description":"styles_description__2Z0Zh"};